import { UserState, UserActions, Maybe } from "../types";
import { Reducer } from "redux";
import { getStartTypeOf, getSuccessTypeOf, getFailureTypeOf } from '../utils/redux';

const initialState = {
  error: null,
  loading: false,
  loggingIn: false,
  loginError: false,
  loginSuccess: false,
  user: null,
  fetchingUser: false,
  fetchUserError: false,
  fetchingData: false,
  fetchDataError: false,
  signingUp: false,
  signUpError: false,
  signUpSuccess: false,
};

const reducer: Reducer<UserState> = (state = initialState, action) => {
  switch (action.type) {
    case getSuccessTypeOf(UserActions.LOGIN):
      return {
        ...state,
        loggingIn: false,
        loginSuccess: true,
      };
    case getStartTypeOf(UserActions.LOGIN):
      return {
        ...state,
        loggingIn: true,
        loginError: false,
        loginSuccess: false,
      };
    case getFailureTypeOf(UserActions.LOGIN):
      return {
        ...state,
        loginError: true,
        loggingIn: false,
      };
    case getStartTypeOf(UserActions.FETCH_USER):
      return {
        ...state,
        fetchingUser: true,
        fetchUserError: false,
      };
    case getFailureTypeOf(UserActions.FETCH_USER):
      return {
        ...state,
        fetchingUser: false,
        fetchUserError: true,
      };
    case getSuccessTypeOf(UserActions.FETCH_USER):
      console.log('fetched user');
      console.log(action.payload);
      return {
        ...state,
        fetchingUser: false,
        user: action.payload,
      };
    case getStartTypeOf(UserActions.SIGN_UP):
      return {
        ...state,
        signingUp: true,
        signUpError: false,
        signUpSuccess: false,
      };
    case getFailureTypeOf(UserActions.SIGN_UP):
      return {
        ...state,
        signUpError: true,
        signingUp: false,
      };
    case getSuccessTypeOf(UserActions.SIGN_UP):
      return {
        ...state,
        signingUp: false,
        signUpSuccess: true,
      };
    default:
      return state;
  } 
};

export default reducer;